import { useGetMediaQuery } from 'src/redux/Api/mediaApi'
import { MediaList } from './MediaList'
import { NewMedia } from './NewMedia'
import Pagination, { Selected } from 'src/Components/Pagination'
import styles from './style.module.scss'
import { useMemo, useState } from 'react'

const MediaPage = () => {
  const [page, setPage] = useState(0)
  const { data, isLoading } = useGetMediaQuery()
  console.log(page)
  const pageChangeHandler = (paginationData: Selected) => {
    setPage(paginationData.selected)
  }

  const pagination = useMemo(() => <Pagination pageCount={3} handlePageClick={pageChangeHandler} />, [])

  return (
    <>
      <h1>Media</h1>
      <section className="block">
        <div className="control">
          <NewMedia />
        </div>
        <MediaList data={data} isLoading={isLoading} />
        <div className={styles.pagination}>{pagination}</div>
      </section>
    </>
  )
}

export default MediaPage
